import { useEffect, useRef } from "react"
import { Card, CardContent, H1 } from "@motleyhand/design"
import { useSubmitContactMutation } from "./api"
import {
  ApiFormWrapper,
  FormError,
  FormInput,
  FormSubmitButton,
  FormTextarea,
} from "@/form"

export default function Contact() {
  const pageLoadRef = useRef(0)
  const [submitContact] = useSubmitContactMutation()

  useEffect(() => {
    pageLoadRef.current = Math.floor(Date.now() / 1000)
  }, [])

  return (
    <div className="mx-auto max-w-lg px-6 py-12">
      <H1>Get in Touch</H1>

      <p className="mb-4 text-muted-foreground">
        Have a question or want to get in touch? Fill out the form below or
        email us directly at{" "}
        <a
          href="mailto:hello@promptjuggler.com"
          className="text-foreground hover:underline"
        >
          hello@promptjuggler.com
        </a>
      </p>

      <Card>
        <CardContent>
          <ApiFormWrapper
            defaultValues={{
              name: "",
              email: "",
              company: null,
              message: "",
              website: null,
            }}
            action={(values) =>
              submitContact({
                ...values,
                t: pageLoadRef.current,
              })
            }
            successMessage="Message sent! We'll get back to you soon."
            resetOnSuccess
          >
            <div className="space-y-4">
              <FormInput
                name="name"
                placeholder="Your name"
                required
                autoFocus
              />
              <FormInput
                name="email"
                type="email"
                autoComplete="email"
                placeholder="Your email"
                required
              />
              <FormInput name="company" placeholder="Your company" />
              <FormTextarea
                name="message"
                placeholder="How can we help you?"
                required
                rows={5}
              />

              {/* Honeypot – hidden from real users */}
              <div className="sr-only" aria-hidden="true">
                <FormInput name="website" tabIndex={-1} autoComplete="off" />
              </div>

              <FormError />
              <FormSubmitButton disabledUntilDirty={false}>
                Send Message
              </FormSubmitButton>
            </div>
          </ApiFormWrapper>
        </CardContent>
      </Card>
    </div>
  )
}
